// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2_J6z","buttons":"PendingPaymentAlert_buttons__AkxuR"};